import { EmploymentPeriodStatusEnum, EmploymentViewModelNew } from '@fora-monorepo/employer-my-pages-common/types';
import { Tag, Text } from '@foradevelopment/fora-ui';

import { useTypedTranslation } from '../../../i18n/i18n';

type EmploymentsTableMarkupContentProps = {
  employment: EmploymentViewModelNew;
};

export const EmploymentsTableMarkupContent = ({ employment }: EmploymentsTableMarkupContentProps) => {
  const { t } = useTypedTranslation();

  const markupExpiringText = employment.activeMarkup?.fokIsExpiring
    ? t('warningMessages.markupIsExpiringChangeText', { endDate: employment.activeMarkup?.fokIsExpiring })
    : undefined;

  const activeEmploymentPeriod = employment.employmentPeriods.find(period => {
    return period.employmentStatus === EmploymentPeriodStatusEnum.Active;
  });

  const activeEmploymentPeriodEndDate = activeEmploymentPeriod?.employmentEndDate;

  const expiredEmploymentPeriods = employment.employmentPeriods.filter(
    period => period.employmentStatus === EmploymentPeriodStatusEnum.Expired
  );

  const lastExpiredEmploymentPeriodEndDate =
    expiredEmploymentPeriods[expiredEmploymentPeriods.length - 1]?.employmentEndDate;

  if ((lastExpiredEmploymentPeriodEndDate && !activeEmploymentPeriod) || activeEmploymentPeriodEndDate) {
    return (
      <Tag
        variant="informational"
        text={t('section.employmentDetails.employmentEndDateTag', {
          endDate: activeEmploymentPeriodEndDate ?? lastExpiredEmploymentPeriodEndDate,
        })}
      />
    );
  }

  if (markupExpiringText) {
    return <Tag variant="informational" text={markupExpiringText} />;
  }

  return (
    <Text size="small" color="black70">
      {!employment.activeMarkup ? t('section.employeeDetails.noActiveMarkupExists') : employment.activeMarkup.fokText}
    </Text>
  );
};
